/***
 * 
 * 聊天消息管理
 * 
 */


const signalR = require("@microsoft/signalr");
let connection = null;

import Idb from 'idb-js'
import db_chart_config from './chart.config'

  /**
   * datas 为json对象，keys为json删除的key的数组
   */
const removeGidUser = (arrs, targetId) => {
  var i = 0;
  while (arrs[i]) {
    if (arrs[i].Gid === targetId) {
      arrs.splice(i, 1);
      return;
    }
    if (arrs[i].children && arrs[i].children.length > 0) {
      this.removeGidUser(arrs[i].children, targetId);
    }
    i++;
  }

}
const sortTime = (x, y) => {
  return y.time - x.time
}

const chartInfo = {

  state: {
    DB: () => {},
    isChartShow: false, //当前是否已经打开对话框
    activeted: 1, // 0== 联系人列表  1==会话列表
    Notify: "", // 导航栏中的消息通知
    UserInlie: {
      number: 0, //在线人数
      list: [], //在线人员列表{...currentUser}
    },
    loginUser: {}, //当前登录人的信息
    currentMsgList: {}, //与某人的聊天消息
    currentUser: { // 正在聊天联系人的信息 
      Gid: "",
      name: "",
      duty: "",
      onLine: true, // 存在新消息
    },
    conversationList: [] // 当前会话列表 {...currentUser}
  },

  actions: {
    //载入配置
    initAction({
      commit,
      state,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {


        commit('SET_LOGINUSER', params)

       // dispatch('connectChart')

        // 
        /***
         * 创建数据表  表名 与当前用户gid一致
         * 
         */
        // dispatch('inIntDB')

        resolve()
      })
    },

    // 创建链接
    connectChart({
      commit,
      state,
      dispatch
    }) {

      connection = new signalR.HubConnectionBuilder()

        .withUrl(process.env.ENV_SIGNLRADRESS + "/MessageHub", {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets
        })

        .withAutomaticReconnect([500, 1500, 3000])
        .build();

      //定义重载
      const ReStart = () => {
        connection.start();
      };

      connection.start().then(() => {

        connection.invoke("userGidToServer", state.loginUser.gid).catch((err) => {
          console.error("链接失败" + err.toString());
        });;

      }).catch((ex) => {
    
        setTimeout(() => ReStart(), 1500);
      });

      connection.onclose(async () => {
        ReStart();
      });


      /***
       * data 用户列表
       * 
       * onlineNum 用户总数
       */
      connection.on("getOnlineUser", (data, onlineNum) => {
        if (data) {
         
          commit('SET_USERINLIE', {
            number: onlineNum,
            list: JSON.parse(data)
          })
        }
      });

      /***
       * 接收消息
       * sendGid：消息来源的gid
       * reveiveGid:接收者的gid
       * message:消息实体
       * time 时间
       */

      connection.on("sendMessageToUser", (sendGid, reveiveGid, message, time) => {

        dispatch('insertList', {
          from: sendGid,
          to: reveiveGid,
          msg: message
        })

      });


      //消息监听 Notify
      connection.on('message', (data) => {
        if (data.length != 0) {
          commit('SET_NOTIFY', data)
        }
      });
    },


    /***
     * 向某人发送一条消息
     * 
     */
    sendMsg({
      commit,
      dispatch,
      state
    }, msg) {
      // console.log(state.currentUser)
      connection.invoke("sendMessageToUser",
        state.loginUser.gid, //自己的id
        state.currentUser.Gid, //目标id
        msg,
        state.currentUser.ConnectionId
      );
    },

    /***************** 数据存储管理器*************************************/

    // 创建存储器
    inIntDB({
      commit,
      state,
      dispatch
    }) {
      Idb(Object.assign(db_chart_config, {
        dbName: process.env.ENV_DBNAME,
      })).then(_db => {
      
        commit('SET_DB', _db)
        dispatch('insertCover')
      });
    },

    //会话数据表排序 conversation 动态
    insertCover({
      state,
      commit,
      dispatch
    }) {

      state.DB.queryAll({
        tableName: 'conversation',
        success: (res) => {
          let _re = res;
          let _array = [];
          _re.sort(sortTime);
          _re.forEach(ele => {
            _array.push(ele.msg);
          });

          commit('SET_CONVERSATLIST', _array);
          dispatch('getChartlist');

        }
      })
    },


    /***加入会话列中 */
    addCoverUser({
        commit,
        dispatch,
        state
      },
      params) {
      if (params) {
        let _read;

        if (params.inState) {
          commit('SET_CURRENTUSER', params)
        }

        if (state.currentUser.Gid === params.Gid) { //处于当前会话窗口
          _read = true;
          //外部增加 提示

        } else {
          _read = false;
        }
       
        try {
          if (!state.isChartShow) { 
               document.getElementById('ChartMsg').classList.add('hasMsg-icon')
          }
       
        } catch (err) {}

        // console.log()

        state.DB.insert({
          tableName: "conversation",
          data: {
            id: params.Gid,
            time: new Date().getTime().toString(),
            msg: Object.assign(params, {
              isRead: _read
            }),

          },
          success: () => {

            dispatch('insertCover')
          }

        });
      }

    },

    //插入与查询某人的聊天记录
    insertList({
      state,
      commit,
      dispatch
    }, params) {
      let _usid;
      if (state.loginUser.gid === params.from) {
        _usid = params.to;
      } else {
        _usid = params.from;
      }

      let _tableName = `ipdc-${state.loginUser.gid + _usid}`;


      state.DB.query_by_index({
        tableName: "chartlist",
        indexName: 'id',
        target: _tableName,
        success: req => {
          let _listArray = [];
          let _cur = {
            from: params.from,
            msg: params.msg
          }
          // 
          if (req != null) {
            _listArray = req['list'].slice(0, 250);
            _listArray.push(_cur)
          } else {
            _listArray.push(_cur);
          }

          dispatch('InsetChartlist', {
            _tableName: _tableName,
            _list: _listArray,
            _usid: _usid
          });

          // TODO: 插入聊天时 查询是否已经存在会话列表中
          let UserOnlineList = state.UserInlie['list'];
          let curUser = UserOnlineList.filter((e) => {
            return e.Gid == _usid
          });

          dispatch('addCoverUser', curUser[0])

        }
      });
    },

    // 正式插入数据
    InsetChartlist({
      state,
      commit,
      dispatch
    }, parmas) {
      state.DB.insert({
        tableName: "chartlist",
        data: {
          id: parmas._tableName,
          list: parmas._list,
        },
        success: () => { }
      });

      //TODO:判读消息用户是否在当前聊天窗口
      if (state.currentMsgList.Gid !== parmas._usid) {

        dispatch('getChartlist', parmas._usid)
      } else {

        dispatch('getChartlist')
      }


    },

    //
    getChartlist({
      state,
      commit,
      dispatch
    }, params) {

      let _usid = state.currentUser.Gid;

      let _tableName = `ipdc-${state.loginUser.gid+_usid}`;

      state.DB.query_by_index({
        tableName: "chartlist",
        indexName: 'id',
        target: _tableName,
        success: req => {
          // 来源消息是否在当前会话列表中
          if (state.activeted == 1) {
            return false
          }

          if (req != null) {
            commit('SET_CURRENTMSGLIST', req)
          } else {
            commit('SET_CURRENTMSGLIST', {
              list: []
            })
          }

        }
      });
    },

  },
  mutations: {
    SET_DB: (state, active) => {
      state.DB = active;
    },

    SET_ACTIVETED: (state, active) => {
      state.activeted = active;
    },
    SET_USERINLIE: (state, active) => {

      state.UserInlie['list'] = [];

      let _gid = state.loginUser.gid;
   
      removeGidUser(active.list, _gid)


      state.UserInlie = active;
    },
    SET_LOGINUSER: (state, active) => {
      state.loginUser = active
    },

    SET_NOTIFY: (state, active) => {
      state.Notify = active.join('  ');
    },

    SET_CONVERSATLIST: (state, active) => {
      state.conversationList = [];
      state.conversationList = active;
    },

    SET_CURRENTUSER: (state, active) => {
      state.currentUser = active;
    },
    SET_CURRENTMSGLIST: (state, active) => {

      state.currentMsgList = active;
    },

    SET_CHARTSHOW: (state, active) => {
      state.isChartShow = active;
    },

  }

}

export default chartInfo
